import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../Helpers/fetcher.js";
import { Notify } from "../../Helpers/notification.js";
import ReactTooltip from 'react-tooltip';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
import { MODULE_LISTING_CONSTANT } from '../../Helpers/constant.js';
import { fetchLocations } from '../../Helpers/subSuperAdmin.api.js';
class LocationManagement extends Component {
	constructor(props) {

		super(props);
		this.state = {
			locationList: [],
			confirmDelete: false,
			selectedLocationId: 0,
			showAddCreditModal: false,
			sizePerPage: 10,
			moduleListingData:props.app.moduleListingData
		}
	}
	componentDidMount() {
		this.getLocation();
		const savedSizePerPage = Cookies.get('locationListsizePerPage');
		if (savedSizePerPage) {
			this.setState({ sizePerPage: Number(savedSizePerPage) });
		}
	}


	getLocation = () => {
		const apiPath = this.props.app.apiPath;

		fetchLocations({
			apiPath,
			isSubSuperAdmin:this.props.app.isSubSuperAdmin,
			moduleListingData: this.state.moduleListingData,
			filterKey: MODULE_LISTING_CONSTANT.MANAGE_LOCATIONS
		})
			.then(res => {
				this.setState({
					locationList: res,
					showAddCreditModal: false,
					confirmDelete: false,
				})
			})
	}

	confirmDelete = (status, locationId) => {
		this.setState({
			confirmDelete: status,
			selectedLocationId: locationId
		});
	}

	deleteLocation = () => {
		const locationId = this.state.selectedLocationId;
		
		const data = {
			
		}

		return Fetcher.post(this.props.app.apiPath + '/api/obd/location/'+locationId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
			.then(res => {
				Notify.notify(res.message);
				this.getLocation();
			})
			.catch(err => {
				console.log('Error in Deleting Location', err);
				Notify.notify('Error in Deleting Location');
			});

	}

	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	setMessageShow = (status) => {
		this.setState({
			showAddCreditModal: false,
		});
	}

	handleSizePerPageChange = (newSizePerPage) => {
		this.setState({ sizePerPage: newSizePerPage });
		Cookies.set('locationListsizePerPage', newSizePerPage);
	}

	render() {

		const locationList = this.state.locationList;
		var columns;
			columns = [
				{
					dataField: 'locationId',
					text: 'Location Id',
					sort: true,
					hidden: false
				},
				{
					dataField: 'locationName',
					text: 'Location Name',
					sort: true,
					searchable: true
				},
				{
					dataField: 'reqDate',
					text: 'Request Date',
					sort: true,
					searchable: true
				},
				{
					dataField: 'action',
					text: 'Action',
					sort: false,
					searchable: false
				},];
		
		const location = Array.isArray(locationList) ? locationList.map((locations, index) => {
				//let action = [ <Link data-tip="Edit Location" key={`${index}-edit-location`} className="edit-location" to={`${this.props.app.urlPrefix}/update-location/${locations.locationId}`}><i className="fa fa-edit"></i></Link> ];
				let action = [<a data-tip="Delete Location" key={`${index}-delete-location`} className="delete-location" onClick={(e) => { this.confirmDelete(true, locations.locationId) }} href="#"><i className="fa fa-trash"></i></a>];
				return {
					locationId: locations.locationId,
					locationName: locations.locationName,
					reqDate: locations.reqDate,
					action: action
				};
			
		}) : []
		const { SearchBar, ClearSearchButton } = Search;

		const defaultSorted = [{
			dataField: 'locationId',
			order: 'desc'
		}];

		const paginationOption = {
			custom: true,
			totalSize: location.length,
			sizePerPage: this.state.sizePerPage,
			sizePerPageList: [10, 25, 50, 100],
			onSizePerPageChange: this.handleSizePerPageChange
		};

		return (
			<Card>
				{/*<Card.Header>Users List<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span></Card.Header>*/}
				<Card.Header>Location List</Card.Header>
				<Card.Body>
					<div className="widget-list-table-cont">
						{/* <h3>Campaign Summary</h3> */}
						{/*{!isEmpty( this.state.locationList ) && <PaginationProvider pagination={paginationFactory( paginationOption )}>*/}
						{<PaginationProvider pagination={paginationFactory(paginationOption)}>
							{
								({
									paginationProps,
									paginationTableProps
								}) => (
									<ToolkitProvider
										keyField="locationId"
										data={location}
										columns={columns}
										search
										bootstrap4

									>
										{
											props => (
												<div className="">
													Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
													<span className="search-cont"><SearchBar  {...props.searchProps} /></span>
													<ClearSearchButton className="btn-primary btn-round" {...props.searchProps} />
													{/*<span>&nbsp;&nbsp;&nbsp;</span><span className="float-none avail-credit-cont"><span className="credits-avail">Available Credits: {this.state.adminCredits}</span></span>*/}
													{/*<Link className="float-right btn btn-default btn-primary" to={`${this.props.app.urlPrefix}/add-cli`}>Allocate CLI</Link>*/}
													
													<BootstrapTable defaultSorted={defaultSorted} bordered={true} hover condensed wrapperClasses="table-responsive" classes="mt-3  widgetlist-table"  {...props.baseProps}  {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
													<PaginationListStandalone {...paginationProps} />
													<ReactTooltip />
												</div>
											)
										}
									</ToolkitProvider>
								)
							}
						</PaginationProvider>}
					</div>

					<Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
						<Modal.Header closeButton>
							<Modal.Title id="example-modal-sizes-title-sm">
								Delete Group
							</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							Are you sure you want to delete this Location?
						</Modal.Body>
						<Modal.Footer>
							<Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
							<Button onClick={this.deleteLocation} variant="primary">YES</Button>
						</Modal.Footer>
					</Modal>

				</Card.Body>
			</Card>

		);
	}
}

export default LocationManagement;